/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { OperationalFilterClearLink } from '../../../shared/filters/OperationalFilterClearLink';
import { OperationalFilterDismissChip } from '../../../shared/filters/OperationalFilterDismissChip';
import { operationalFilterStyles } from '../../../shared/filters/operationalFilters.styles';
import type { PosCatalogActiveFilterChipKey } from '../../application/posActiveCatalogFiltersSummary';

export type PosCatalogActiveFilterChipView = {
  key: PosCatalogActiveFilterChipKey;
  label: string;
  onDismiss: () => void;
};

type Props = {
  chips: PosCatalogActiveFilterChipView[];
  onClearAll: () => void;
  testID?: string;
};

export function PosCatalogActiveFiltersRow({ chips, onClearAll, testID = 'pos.filters.chips' }: Props) {
  if (chips.length === 0) return null;

  return (
    <View style={styles.row} testID={testID}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
        style={styles.scroll}
        contentContainerStyle={operationalFilterStyles.chipScrollContent}
      >
        {chips.map((chip) => (
          <OperationalFilterDismissChip
            key={chip.key}
            label={chip.label}
            onDismiss={chip.onDismiss}
            testID={`${testID}.${chip.key}`}
          />
        ))}
      </ScrollView>
      <OperationalFilterClearLink
        onPress={onClearAll}
        label="Limpiar"
        accessibilityLabel="Limpiar filtros"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    alignSelf: 'stretch',
    minHeight: 36,
  },
  scroll: {
    flex: 1,
    minWidth: 0,
  },
});
